import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import RadioButton from "../../../../../components/ui/RadioButton";
import Button from "../../../../../components/ui/Button";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import OverflowText from "../../../../../components/ui/Textoverflow";

import DomainInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/AssociatedDomain/DomainInformation";
import SSLCertificate from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/AssociatedDomain/SSLCertificate";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { filterIcon, searchIcon } from "../../../../../utils/icons";
import { formatNumber } from "../../../../../utils/util";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getAssociatedDomainList, getAssociatedDomainSSL, getScanInfoStats, resetScanInfoStats, resetAssociatedDomainList } from "../../../../../store/actions/scanInfoAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const AssociatedDoamin = () => {
    
    const associatedDomainListResponse = useSelector((state) => state.scanInfo?.associatedDomainList);
    const associatedDomainSSLResponse = useSelector((state) => state?.scanInfo?.associatedDomainSSL);
    const associateDomainStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const filterWrapperRef = useRef(null);

    const [activeTab, setActiveTab] = useState("domainInformation");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedAssociatedDomain, setSelectedAssociatedDomain] = useState("");
    const [isSSLloading, setIsSSLloading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [associatedDomainStats, setAssociatedDomainStats] = useState("");
    const [associatedDomainLists, setAssociatedDomainLists] = useState(null);

    const [statsloading, setStatsLoading] = useState(false);

    //search value
    const [associatedDomainSearch, setAssociatedDomainSearch] = useState("");
    const [updatedAssociatedDomainSearchValue, setUpdatedAssociatedDomainSearchValue] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");

    //selected filter value
    const [filterSelectedFindingsType, setFilterSelectedFindingsType] = useState("");

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true)
    };

    const applyFilter = () => {
        setCurrentPage(1);
        setFilterSelectedFindingsType(newFindingsType)
        setShowFilter(false);
        setContextCurrentPage(1);
        setTriggerListFetch(true)
    }

    const requestSearch = useMemo(() => debounce((searchTerm) => {
        setUpdatedAssociatedDomainSearchValue(searchTerm)
    }, 500), []);

    const fetchAssociatedDomainStats = useCallback(() => {
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.associatedDomain.associatedDomainStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url));
    },[dispatch, domainId, scanId, organizationId])

    const associatedDomainList = useCallback(()=>{
        const baseUrl = `&page=${currentPage}&page_size=10`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedAssociatedDomainSearchValue ? `&query=${updatedAssociatedDomainSearchValue}` : "";
        const newFindings = filterSelectedFindingsType && filterSelectedFindingsType !== "all" ? `&new_record=${filterSelectedFindingsType === "yes" ? true : false}` : ""
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        setIsLoading(true);
        setScanNotFound(false);
        dispatch(getAssociatedDomainList(url))
    },[dispatch, domainId, scanId, organizationId, currentPage, updatedAssociatedDomainSearchValue, filterSelectedFindingsType]);
    

    const fetchSSLcertificate = useCallback(()=>{
        setIsSSLloading(true);
        let url = `&page=1&page_size=10&domain=${selectedAssociatedDomain?.domain}&scan_id=${selectedAssociatedDomain?.scan_id}&associated_domain=${selectedAssociatedDomain?.associated_domain}`;        
        dispatch(getAssociatedDomainSSL(url))
    },[dispatch, selectedAssociatedDomain])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])

    useEffect(()=>{
        if(selectedAssociatedDomain && activeTab === "SSlCertificate") {
            setIsSSLloading(true);
            fetchSSLcertificate()
        }
    },[selectedAssociatedDomain, fetchSSLcertificate, activeTab])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchAssociatedDomainStats();
            setCurrentPage(1)
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchAssociatedDomainStats]);

    useEffect(() => {
        if (triggerListFetch) {
            associatedDomainList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, associatedDomainList]);

    useEffect(() => {
        setCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedAssociatedDomainSearchValue]);

    useEffect(()=>{        
        if(associatedDomainListResponse !== null) {
            setAssociatedDomainLists(associatedDomainListResponse)
            if(associatedDomainListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(associatedDomainListResponse?.results?.length > 0) {                
                setSelectedAssociatedDomain(associatedDomainListResponse?.results[0])
            } else {
                setSelectedAssociatedDomain([])
            }            
            dispatch(resetAssociatedDomainList())
            setIsLoading(false);
        }
    },[associatedDomainListResponse, dispatch])

    useEffect(()=>{
        if(associatedDomainSSLResponse !== null) {
            setIsSSLloading(false);
        }
    },[associatedDomainSSLResponse])

    useEffect(()=>{        
        if(associateDomainStatsResponse !== null) {
            setStatsLoading(false)
            setAssociatedDomainStats(associateDomainStatsResponse)
            dispatch(resetScanInfoStats())
        }
    },[associateDomainStatsResponse, dispatch])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>                        
                        <Col lg={4}>
                            <div className="discover-doamin-container associated-doamin-page rounded p-3">
                                {
                                    statsloading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"associatedDomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Associated Domains</p>
                                            {/* <p className="view-all">View all</p> */}
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(associatedDomainStats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(associatedDomainStats?.record_type?.new_record)}</span> New </p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(associatedDomainStats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>Associated Domain List</h1>
                                    {filterSelectedFindingsType !== "" && (<span className="reset-filter-link" onClick={()=>{
                                        setNewFindingsType("")
                                        setFilterSelectedFindingsType("")
                                        setContextCurrentPage(1)
                                        setTriggerListFetch(true)
                                    }}>Reset Filter</span>)}
                                    <div className="position-relative">
                                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                            <h6>New Findings</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="filter-apply-btn mt-3">
                                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === ""} buttonClicked={()=>{applyFilter()}}/>
                                            </div>
                                        </div>}
                                    </div>                                    
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input" 
                                        value={associatedDomainSearch} 
                                        onChange={(e)=>{
                                            setAssociatedDomainSearch(e.target.value)
                                            requestSearch(e.target.value)
                                            setCurrentPage(1)
                                        }}
                                    />
                                </div>
                                <div className="list-main-container">
                                    { !isLoading && scanNotFound &&
                                        <NoDataFound noDataText={associatedDomainLists?.description}/>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                        <SkeletonLoader type={"line"} count={4} currentPage={"associatedDomain"} />
                                        :
                                        (
                                            associatedDomainLists?.results?.length > 0 &&
                                            associatedDomainLists?.results?.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${selectedAssociatedDomain?.id === data?.id ? "active" : ""}`} onClick={()=>{setSelectedAssociatedDomain(data)}}>
                                                            <div className={`d-flex align-items-center subdomain-name gap-2 mb-2 ${!data?.new_record ? "full-width" : ""}`}>
                                                                <OverflowText text={data?.associated_domain} className={"sub-domain-heading"}/>
                                                                {data?.new_record && <span className="new-subdomain">New</span>}
                                                            </div>
                                                            <p className="sub-domain-name">{data?.domain}</p>
                                                            {data?.additional_info?.blacklisted?.is_blacklisted &&  <span className="subdomain-status blacklisted">Blacklisted</span>}
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && associatedDomainLists?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={associatedDomainLists?.meta?.total_results}
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                        />                                  
                                    }
                                    { !isLoading && associatedDomainLists?.results?.length === 0 &&
                                        <NoDataFound noDataText={"Associated Domain Not Found"}/>
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "domainInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('domainInformation')}}>Domain Information</p>
                                    <p className={`rounded text-center ${activeTab === "SSlCertificate" ? "active" : ""}`} onClick={()=>{setActiveTab('SSlCertificate')}}>SSL Certificate</p>
                                </div>
                                <div className="tab-details-content mt-3">
                                    {
                                        isLoading ?
                                        <SkeletonLoader type={"line"} count={4} currentPage={"associatedDomain"} />
                                        :
                                        <>
                                            {activeTab === "domainInformation" &&
                                                <>
                                                    {selectedAssociatedDomain === "" ? 
                                                        <NoDataFound noDataText={"Please select Any Associated Domain"}/>
                                                        :
                                                        <motion.div
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4 }}
                                                        >
                                                            <DomainInformation SimilarDomainData={selectedAssociatedDomain} currentPageType={"associatedDomain"}/>
                                                        </motion.div>
                                                    }
                                                    
                                                
                                                </>
                                            }
                                            {activeTab === "SSlCertificate" && 
                                                <>
                                                    {selectedAssociatedDomain === "" ?
                                                        <NoDataFound noDataText={"Please select Any Associated Domain"}/>
                                                        :
                                                        <motion.div
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4 }}
                                                        >
                                                            <SSLCertificate sslCertificateData={associatedDomainSSLResponse} isLoading={isSSLloading}/>
                                                        </motion.div>
                                                    }
                                                    
                                                </>
                                            }    
                                        </>
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}


export default AssociatedDoamin;